import { Dispatch } from "react";
import { AnyAction } from "redux";
import { runInnerFunction } from "../../compatManager";
import { setConveyancerState, setFireInsuranceAgentState, setLawyerListState, setSelectedLawyer, setMortgageBrokerState, setMortgageLenderState, setPurchaserRealEstateBrokerState, setRealEstateBrokerState, setOtherPartyState, setSelectFileListState, setThirdPartyListState, setDRFileListState, setSkipSetThirdPartyData, lddStateObject } from "../../redux/reducer";
import { NavObjectType, PopupPageId, ProvincesShortCode } from '../navigationTypes';
import { ThirdPartyListItem } from "./ThirdPartyTypes";
import { Badge } from "react-bootstrap";
import { useAppSelector } from "../../redux/hooks";

export function setThirdPartyData(thirdPartyEntry: ThirdPartyListItem, thirdPartyType: string): number {
    let thirdPartyInfo = {
        qpickrepository_id: thirdPartyEntry.qpickrepository_id,
        indexattributevalue: thirdPartyEntry.indexattributevalue,
        Name: thirdPartyEntry.Name,
        LawyerID: thirdPartyEntry.LawyerID,
        FirmName: thirdPartyEntry.FirmName,
        DirectPhone: thirdPartyEntry.DirectPhone,
        Address: thirdPartyEntry.Address,
        QPickType: thirdPartyType,
    }
    for (var key in thirdPartyInfo) {
        if (thirdPartyInfo[key] === null || thirdPartyInfo[key] === undefined)
            thirdPartyInfo[key] = '';
    }    
    const index: string = runInnerFunction('ReactShell.reactSetQPick', thirdPartyInfo);
    return Number(index);
}

export function BuildThirdPartyHeaders(
    columns: string[],
    sort: (column: string) => void,
    prov: string,
    getSortIcon: (column: string) => JSX.Element,
    showDelete?: boolean
) {
    const province : ProvincesShortCode = useAppSelector((g) => g.SessionInfo.appProvinceShort);
    const handleClick = (columnAttr: string) => {
        sort(columnAttr);
    }

    const getWidth = () => {
        var columnCount = columns.length;
        let width = 100;

        if (columns.includes('isNotary')) {
            width -= 3;
            columnCount -= 1;
        }
        if (columns.includes('LawyerID')) {
            width -= 3;
            columnCount -= 1;
        }
        if (showDelete) {
            width -= 4;
        }

        return width / columnCount;
    }

    return (
        <tr>
            {columns.map(col => {
                switch (col) {
                    case 'indexattributevalue':
                        return (
                            <th key={`th-${col}`} style={{ cursor: "pointer" , width: `${getWidth()}%`}} data-name={col} onClick={() => handleClick(col)}>
                                {getSortIcon(col)}
                                Name
                            </th>
                        )
                    case 'isNotary':
                        if (province != 'BC') {
                            return (<></>);
                        }
                        return(
                            <th key={`th-${col}`} style={{ cursor: "default", width: `3%` }} data-name={col}>
                                Type
                            </th>
                        )
                    case 'FirmName':
                        return (
                            <th key={`th-${col}`} style={{ cursor: "pointer", width: `${getWidth()}%` }} data-name={col} onClick={() => handleClick(col)}>
                                {getSortIcon(col)}
                                Firm
                            </th>
                        )
                    case 'Name':
                        return (
                            <th key={`th-${col}`} style={{ cursor: "pointer", width: `${getWidth()}%` }} data-name={col} onClick={() => handleClick(col)}>
                                {getSortIcon(col)}
                                Agent
                            </th>
                        )
                    case 'Address':
                        return (
                            <th key={`th-${col}`} style={{ cursor: "pointer", width: `${getWidth()}%`}} data-name={col} onClick={() => handleClick(col)}>
                                {getSortIcon(col)}
                                Address
                            </th>
                        )
                    case 'LawyerID':
                        return (
                            <th key={`th-${col}`} style={{ cursor: "default", width: `3%` }} data-name={col}>
                                Owner
                            </th>
                        )
                    default:
                        return (<></>)
                }
            })}
            {showDelete && <th key="th-delete" style={{ cursor: "default", width: `4%` }} data-name="delete"></th>}
        </tr>
    )
}

export function BuildThirdPartyListLink(
    columns: string[],
    dataroot: any,
    nodeName: string,
    navObj?: NavObjectType,
    navigateContext?: (navObject: NavObjectType, init?: boolean) => void,
    province?: ProvincesShortCode,
    searchString?: string,
    dispatch?: React.Dispatch<any>,
    skipSetThirdPartyData?: boolean,
    onDeleteEntry?: (entry: ThirdPartyListItem) => void,
) {
    const getWidth = () => {
        var columnCount = columns.length;
        let width = 100;

        if (columns.includes('isNotary')) {
            width -= 3;
            columnCount -= 1;
        }
        if (columns.includes('LawyerID')) {
            width -= 3;
            columnCount -= 1;
        }
        if (onDeleteEntry) {
            width -= 4;
        }

        return width / columnCount;
    }

    const boldSearch = (text: string, searchString: string) : JSX.Element => {
        if (text == null || text == undefined) {
            return <></>;
        }

        if (text == '' || searchString == '') {
            return <>{text}</>;
        }

        const textTokens = text.split(new RegExp(`(${searchString.replace(/[#-.]|[[-^]|[?|{}]/g, '\\$&')})`, 'gi'));

        return <>{
            textTokens.map((token, index) => {
                if (token.toLowerCase() === searchString.toLowerCase()) {
                    return <b key={index}>{token}</b>;
                }
                return <>{token}</>;
            })
        }</>;
    }

    return (ThirdPartyEntry: ThirdPartyListItem) => {
        return (
            <tr key={`${ThirdPartyEntry['qpickrepository_id']}`} 
                onClick={async () => {
                    if(skipSetThirdPartyData){
                        await dispatch(setSelectedLawyer(ThirdPartyEntry));
                        await dispatch(setLawyerListState(false));
                        await dispatch(setSkipSetThirdPartyData(false));
                        return;
                    }
                    const retIndex = setThirdPartyData(ThirdPartyEntry, nodeName);
                    await dispatch(setLawyerListState(false));
                    navObj.controller.tabNumber = retIndex + 1;
                    if (nodeName === "Solicitor" || nodeName === "VendorSolicitor") {
                        navObj.actionParam = nodeName;
                        if (nodeName === "VendorSolicitor") {
                            navObj.controller.tabName = PopupPageId.VendorSolicitor;
                        }
                    }
                    navigateContext(navObj);
                    
                }}>
                {columns.map(col => {
                     if (col === "indexattributevalue") {
                        return (
                            <td key={`${ThirdPartyEntry['qpickrepository_id']}-${col}`} style={{width: `${getWidth()}%`}}>
                                {boldSearch(ThirdPartyEntry['indexattributevalue'], searchString)}
                            </td>
                        )
                    } else if (col === "isNotary" && province == 'BC') {
                        return (
                            <td key={`${ThirdPartyEntry['qpickrepository_id']}-${col}`} style={{width: `3%`}}>
                                {ThirdPartyEntry['isNotary'] == 1 ? 
                                <Badge bg="secondary" text="light" pill>Notary</Badge> : 
                                <Badge bg="secondary" text="dark" pill>Lawyer</Badge>}
                            </td>
                        )
                    } else if (col === "FirmName") {
                        return (
                            <td key={`${ThirdPartyEntry['qpickrepository_id']}-${col}`} style={{width: `${getWidth()}%`}}>
                                {boldSearch(ThirdPartyEntry['FirmName'], searchString)}
                            </td>
                        )
                    } else if (col === "Name") {
                        return (
                            <td key={`${ThirdPartyEntry['qpickrepository_id']}-${col}`} style={{width: `${getWidth()}%`}}>
                                {ThirdPartyEntry['Name']}
                            </td>
                        )
                    } else if (col === "Address") {
                        return (
                            <td key={`${ThirdPartyEntry['qpickrepository_id']}-${col}`} style={{width: `${getWidth()}%`}}>
                                {ThirdPartyEntry['Address'] != null ? boldSearch(ThirdPartyEntry['Address'], searchString) : ''}
                            </td>
                        )
                    } else if (col === "LawyerID") {
                        return (
                            <td key={`${ThirdPartyEntry['qpickrepository_id']}-${col}`} style={{width: `3%`}}>
                                {ThirdPartyEntry['LawyerID'] === null || ThirdPartyEntry['LawyerID'] === "" || ThirdPartyEntry['LawyerID'] === 'system' ?
                                    <Badge bg="system" text="dark" pill>System</Badge>
                                    : <Badge bg="success" text="dark" pill>User</Badge>}
                            </td>
                        )
                    } else {
                        return (<></>)
                    }
                })}
                {onDeleteEntry &&
                    <td key={`${ThirdPartyEntry['qpickrepository_id']}-delete`} style={{width: `4%`, textAlign: "center"}}>
                        {!(ThirdPartyEntry['LawyerID'] === null || ThirdPartyEntry['LawyerID'] === "" || ThirdPartyEntry['LawyerID'] === 'system') &&
                            <i className="fa-regular fa-trash-can fa-action" title="Delete this entry from your list"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onDeleteEntry(ThirdPartyEntry);
                                }}
                            ></i>}
                    </td>}
            </tr>
        )


    }
}

export function ThirdPartyDispatch(dispatch: Dispatch<AnyAction>, thirdPartyOption: string, state: boolean, extraPayload?: Record<string, string>, _shouldShowPopup?: boolean) {
    switch (thirdPartyOption) {
        case "LenderCentre":
            dispatch(setThirdPartyListState(state ? 'showLenderCentre' : ''));
            break;
        case "MortgageDropbox":
            dispatch(setThirdPartyListState(state ? 'showMortgageDropbox' : '', extraPayload || {}));
            break;
        case "DRDisconnect":
            dispatch(setThirdPartyListState(state ? 'showDRDisconnect' : ''));
            break;
        case "FireInsurer":
        case 'FireInsurance':
        case "InsuranceList":
            dispatch(setFireInsuranceAgentState(state));
            break;
        case "RealEstateBroker":
        case "RealEstateBrokerList":
            dispatch(setRealEstateBrokerState(state));
            break;
        case "OtherParty":
            dispatch(setOtherPartyState(state, extraPayload));
            break;
        case "PurchaserRealEstateBroker":
        case "PurchaserRealEstateBrokerList":
            dispatch(setPurchaserRealEstateBrokerState(state));
            break;
        case "Conveyancer":
        case "ConveyancerList":
            dispatch(setConveyancerState(state));
            break;
        case "MortgageBroker":
        case "MortgageBrokerList":
            dispatch(setMortgageBrokerState(state));
            break;
        case "MortgageLender":
        case "MortgageLenderList":
        case "MortgageBranchList":
        case "AllMortgageLenderList":
            dispatch(setMortgageLenderState(state));
            break;
        case 'AllLawyerList':
        case 'Solicitor':
        case "LawyerList":
        case "NotaryList":
            dispatch(setLawyerListState(state, extraPayload));
            break;
        case "SelectFileList":
            dispatch(setSelectFileListState(state));
            break;
        case "DRFileList":
            dispatch(setDRFileListState(state));
            break;
        default:
            dispatch(setMortgageLenderState(state));
            break;
    }
}